import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import useUser from '../global/useUser';
import { getItems } from '../../services/items';

interface Options {
  includeDeleted?: boolean;
}

function useGetItems({ includeDeleted = false }: Options = {}) {
  const { user } = useUser();

  const queryKey = useMemo(
    () => ['retail-items', user?.business?.id, user?.role, includeDeleted],
    [user?.business?.id, user?.role, includeDeleted],
  );

  const { data, isLoading, isFetching, isError, error, refetch } = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey,
    queryFn: async () => {
      const items = await getItems({
        businessId: user?.business?.id!,
        includeDeleted,
      });

      return items;
    },
  });

  return {
    queryKey,
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  };
}

export default useGetItems;
